import { ConfigProvider, Table, TableProps } from 'antd';
import { AnyObject } from 'antd/es/_util/type';
import { RenderEmptyHandler } from 'antd/es/config-provider';

export type SelectTableProps<ItemType> = Omit<TableProps<ItemType>, 'onChange'> & {
  single?: boolean;
  value?: React.Key | React.Key[];
  onChange?: (newValue: React.Key | React.Key[]) => void;
  onTableChange?: TableProps<ItemType>['onChange'];
  renderEmpty?: RenderEmptyHandler | undefined;
};

export const SelectTable = <ItemType extends AnyObject>({
  single,
  rowKey = 'id',
  rowSelection,
  size = 'small',
  value,
  onChange,
  onTableChange,
  renderEmpty,
  ...props
}: SelectTableProps<ItemType>) => {
  const _rowSelection: TableProps<ItemType>['rowSelection'] = {
    ...rowSelection,
    selectedRowKeys: Array.isArray(value) ? value : value ? [value] : [],
    type: single ? 'radio' : undefined,
    onChange: (selectedRowKeys) => {
      const newValue = single ? selectedRowKeys[0] : selectedRowKeys;
      onChange && onChange(newValue);
    },
  };

  return (
    <ConfigProvider renderEmpty={renderEmpty}>
      <Table rowKey={rowKey} rowSelection={_rowSelection} size={size} onChange={onTableChange} {...props} />
    </ConfigProvider>
  );
};
